// extracted by mini-css-extract-plugin
module.exports = {"Logo":"K9XFt","Logo__Icon":"isrI7","Logo__Year":"PDKkd","Logo__TextAccent":"_6VVdK"};